import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 180px;
  padding-bottom: 80px;
  flex-direction: column;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  border-bottom: 1px solid #E3E3E3;
  margin-top: 80px;

  @media screen and (max-width: 767px) {
    width: 85%;
    margin-top: 50px;
  }
`;

export const Question = styled.div`
  font-family: Poppins-Regular;
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  color: #000;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  display: flex;

  @media screen and (max-width: 767px) {
    padding: 20px 0;
    font-size: 14px;
    line-height: 21px;
  }
`;

export const QuestionWrapper = styled.div`
  padding: 30px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  padding-right: 10px;
  border-top: 1px solid #E3E3E3;

  &:hover {
    background: #f7f7f7;
  }
`;

export const Answer = styled.div`
  padding: 20px 10px;

  @keyframes slideInFromLeft {
    0% {
      transform: translateY(-40%);
    }
    100% {
      transform: translateY(0);
    }
  }

  animation: 0.3s ease-out 0s 1 slideInFromLeft;
`;
